import React, { useMemo } from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole panel; each part uses its own slice of it */
import styles from './PresavePanel.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PresaveSparkBarsProps {
  series: { date: string; count: number }[];
}

/**
 * A week of email sign-ups, one bar a day, oldest first. No axis and no
 * numbers: it is here to show a shape — flat, climbing, or one good day.
 */
const PresaveSparkBarsComponent: React.FC<PresaveSparkBarsProps> = ({ series }) => {
  const bars = useMemo(() => {
    const max = Math.max(1, ...series.map((point) => point.count));
    return series.map((point, index) => ({
      key: point.date,
      // A flat week still draws a floor, so the row never reads as missing.
      height: point.count === 0 ? 8 : Math.max(12, (point.count / max) * 100),
      isLast: index === series.length - 1,
    }));
  }, [series]);

  if (bars.length === 0) {
    return null;
  }

  return (
    <div className={styles.spark}>
      {bars.map((bar) => (
        <i
          key={bar.key}
          className={clsx(styles.sparkBar, bar.isLast && styles.sparkBarLast)}
          style={{ height: `${bar.height}%` }}
        />
      ))}
    </div>
  );
};

export const PresaveSparkBars = TypedMemo(PresaveSparkBarsComponent);
